import {Navigate} from "react-router-dom";

import {useStoredMe} from "../store/me";

export default function AdminGuard({children}: {children: React.ReactNode}) {
  const me = useStoredMe();

  if (!me?.isAdmin) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
